var app = angular.module('leonardo');

var HasErrorInputDirective = function(ConfigThemeService) {
  return {
    restrict: 'AC',
    scope: {
      error:'=?'
    },
    link: function (scope, element) {

      scope.$watch(
        function () {
          return scope.error;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.setColor();
          }
        }
      );

      scope.setColor = function() {
        if (scope.error) {
          element.find('input').css('border-color', ConfigThemeService.getColor('errorColor'));
          element.find('.cke').css('border-color', ConfigThemeService.getColor('errorColor'));
        }
        else {
          element.find('input').css('border-color', ConfigThemeService.getColor('tertiaryColor'));
          element.find('.cke').css('border-color', ConfigThemeService.getColor('tertiaryColor'));
        }
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('hasErrorInput', ['ConfigThemeService', HasErrorInputDirective]);
